export { default } from "./DetailTags";
export * from "./DetailTags";
